"use client";

import { useCallback } from "react";
import Link from "next/link";

import PostCardImg from "../PostCardImg";
import Badges from "../Badges";
const styles = new Proxy({"PostCard":"PostCard-6d6f8","CardTitle":"CardTitle-6d6f8","CardText":"CardText-6d6f8","CardBody":"CardBody-6d6f8","CardFooter":"CardFooter-6d6f8"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import { Tag } from "@/themes/ci/blog/types";

const PostCard = ({
  post: { featuredImage, title, scheduledAt, author, excerpt, link, tags },
  isFirst,
  className = "col-lg-4",
  router,
}: {
  post: {
    featuredImage: { src: string; alt: string; url: string };
    title: string;
    scheduledAt: string;
    author: { name: string };
    excerpt: string;
    link: string;
    tags: Tag[];
  };
  isFirst?: boolean;
  className?: string;
  router?: any;
}) => {
  const onClick = useCallback(() => {
    router?.push(link);
  }, [router, link]);

  return (
    <div className={`my-3 col-12 ${className}`}>
      <div className={styles.PostCard}>
        <PostCardImg post={{ featuredImage, link }} priority={isFirst} />

        <div className={styles.CardBody} onClick={onClick} role="link">
          <div className="mb-2" style={{ fontSize: 14, color: "#738795" }}>
            <strong>{author.name}</strong>
            <span className="ms-2">{scheduledAt}</span>
          </div>

          <h3 className={styles.CardTitle}>
            <Link href={link}>
              <span>{title}</span>
            </Link>
          </h3>

          <div className={styles.CardText}>
            <p style={{ cursor: "pointer" }}>{excerpt}</p>
          </div>

          <div className="mt-3">
            <Link href={link} className="mainlink">
              Read more
            </Link>
          </div>
        </div>

        <div className={styles.CardFooter}>
          <Badges badges={tags} limit={2} />
        </div>
      </div>
    </div>
  );
};

export default PostCard;
